var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-chat-empty"},[_c('i',{staticClass:"fa fa-magic"}),_c('span',[_vm._v("Ask AI agent to help with your creative:")]),_c('ul',{staticClass:"ai-chat-empty-hints"},_vm._l((_vm.hints),function(hint){return _c('li',{key:hint},[_vm._v(_vm._s(hint))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }